import { required } from 'vuelidate/lib/validators'

const departamentoEhVazio = (value,vm) => !(vm.departamentoEhVazio.length == 0)

export const validateData = {
  form: {
    operadores: { required },
  },
  departamentosSelecionados:{ departamentoEhVazio }
}

export const validateComputed = {
  operadoresErrors() {
    const errors = []
    if (!this.$v.form.operadores.$dirty) return errors
    !this.$v.form.operadores.required && errors.push('Campo obrigatório.')
    return errors
  },
  
  departamentoErrors(){
    const errors = []
    if (!this.$v.departamentosSelecionados.$dirty) return errors
    !this.$v.departamentosSelecionados.departamentoEhVazio && errors.push('Departamento Vazio.')
    !this.$v.form.operadores.required && errors.push('Campo obrigatório.')
    return errors
  },

}
